import { useState, useEffect } from "react";
import { X } from "lucide-react";

export const HomePopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasShown = sessionStorage.getItem("homePopupShown");
    if (!hasShown) {
      setIsOpen(true);
      sessionStorage.setItem("homePopupShown", "true");
    }
  }, []);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[4000] flex items-center justify-center p-5"
      onClick={() => setIsOpen(false)}
      role="dialog"
      aria-modal="true"
      aria-label="Poultry India 2026 Invitation"
    >
      {/* Backdrop overlay with 3px blur matching Poultry India .pi-ad-popup-backdrop */}
      <div className="absolute inset-0 bg-[#0f1423]/60 backdrop-blur-[3px]" />

      {/* Main Popup Box matching Poultry India .pi-ad-popup-box */}
      <div
        className="pi-ad-box-intron"
        style={{
          width: "min(560px, 92vw, calc(92vh - 84px))",
          maxWidth: "92vw",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button matching Poultry India .pi-ad-popup-close */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute -top-[14px] -right-[14px] z-30 flex items-center justify-center w-[38px] h-[38px] bg-white text-[#111] hover:bg-[#E85222] hover:text-white rounded-full shadow-[0_4px_14px_rgba(0,0,0,0.35)] transition-all duration-200 hover:scale-105 hover:rotate-90 cursor-pointer border-none leading-none"
          aria-label="Close"
        >
          <X className="w-5 h-5 stroke-[2.5]" />
        </button>

        {/* Media Container matching Poultry India .pi-ad-popup-video-wrap */}
        <div
          style={{
            position: "relative",
            lineHeight: 0,
            borderRadius: "14px",
            overflow: "hidden",
            background: "#000",
            width: "100%",
            aspectRatio: "1 / 1",
          }}
        >
          <img
            src="/img/invitation_poultry_india_2026.jpg"
            alt="Poultry India 2026 Invitation"
            className="select-none"
            style={{
              display: "block",
              width: "100%",
              height: "100%",
              aspectRatio: "1 / 1",
              objectFit: "cover",
              borderRadius: "14px",
            }}
          />
        </div>
      </div>
    </div>
  );
};
